import { render } from "./CookSectionRating.vue?vue&type=template&id=2fa6aaaa&scoped=true"
import script from "./CookSectionRating.vue?vue&type=script&lang=js"
export * from "./CookSectionRating.vue?vue&type=script&lang=js"

import "./CookSectionRating.vue?vue&type=style&index=0&id=2fa6aaaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa6aaaa"]])

export default __exports__